import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { BadgeModule } from 'primeng/badge';
import { StyleClassModule } from 'primeng/styleclass';

@Component({
  selector: 'ui-floating-menu',
  standalone: true,
  imports: [
    CommonModule,
    BadgeModule,
    StyleClassModule,
    RouterOutlet,
    RouterLink,
  ],
  template: `
    <div
      class="resize-container-5 min-h-screen flex flex-col bg-surface-50 dark:bg-surface-950"
    >
      <div
        class="bg-surface-0 dark:bg-surface-900 py-4 px-8 flex items-center justify-between border-b border-surface-200 dark:border-surface-700"
      >
        <div class="flex items-center gap-4">
          <a
            pStyleClass="#app-sidebar-floating"
            enterFromClass="hidden"
            enterActiveClass="animate-fadeinleft"
            leaveToClass="hidden"
            leaveActiveClass="animate-fadeoutleft"
            [hideOnOutsideClick]="true"
            resizeSelector=".resize-container-5"
            class="cursor-pointer flex items-center justify-center lg:hidden text-surface-700 dark:text-surface-100"
          >
            <i class="fa-solid fa-bars text-xl! leading-none!"></i>
          </a>
          <div class="flex items-center gap-4 lg:w-[280px] mr-8">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="33"
              height="32"
              viewBox="0 0 33 32"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.59219 2.87829C6.44766 3.67858 5.4127 4.62478 4.51426 5.68992C8.1857 5.34906 12.8501 5.90564 18.2655 8.61335C24.0484 11.5047 28.705 11.6025 31.9458 10.9773C31.6517 10.087 31.2815 9.23135 30.843 8.41791C27.1332 8.80919 22.3772 8.29127 16.8345 5.51998C13.3148 3.76014 10.2122 3.03521 7.59219 2.87829ZM28.6759 5.33332C25.7462 2.06 21.4887 0 16.75 0C15.3584 0 14.0081 0.177686 12.7209 0.511584C14.4643 0.987269 16.3163 1.68319 18.2655 2.65781C22.3236 4.68682 25.8271 5.34013 28.6759 5.33332ZM32.6387 14.1025C28.7235 14.8756 23.317 14.7168 16.8345 11.4755C10.774 8.44527 5.95035 8.48343 2.69712 9.20639C2.5292 9.24367 2.36523 9.28287 2.20522 9.32367C1.7793 10.25 1.43931 11.2241 1.19536 12.2356C1.45591 12.166 1.72514 12.0998 2.00293 12.0381C5.94966 11.161 11.5261 11.1991 18.2655 14.5689C24.3261 17.5991 29.1497 17.561 32.4029 16.838C32.5144 16.8133 32.6242 16.7877 32.7322 16.7613C32.7441 16.509 32.75 16.2552 32.75 16C32.75 15.358 32.7122 14.7248 32.6387 14.1025ZM32.2098 20.1378C28.3326 20.8157 23.0836 20.5555 16.8345 17.431C10.774 14.4008 5.95035 14.439 2.69712 15.1619C1.975 15.3223 1.32539 15.5178 0.752344 15.7241C0.750782 15.8158 0.75 15.9078 0.75 16C0.75 24.8366 7.91344 32 16.75 32C24.1557 32 30.3862 26.9687 32.2098 20.1378Z"
                class="fill-surface-900 dark:fill-surface-0"
              />
            </svg>
            <span
              class="text-lg font-semibold leading-tight text-surface-900 dark:text-surface-0"
              >Trimzales</span
            >
          </div>
        </div>

        <div class="flex items-center justify-between flex-1">
          <div class="hidden md:flex items-center gap-2">
            <a
              class="text-surface-600 dark:text-surface-400 text-base font-normal cursor-pointer"
              >Bookmarks</a
            >
            <i
              class="pi pi-angle-right text-base! leading-none! text-surface-600 dark:text-surface-400"
            ></i>
            <a
              class="text-surface-600 dark:text-surface-400 text-base font-normal cursor-pointer"
              >Favorites</a
            >
          </div>

          <div class="flex items-center gap-4 md:gap-8 ml-auto">
            <i
              class="pi pi-bell text-xl! leading-none! text-surface-500 dark:text-surface-400 cursor-pointer"
            ></i>
            <img
              src="https://fqjltiegiezfetthbags.supabase.co/storage/v1/render/image/public/block.images/blocks/avatars/avatar-amyels.png"
              class="w-8 h-8 rounded-full cursor-pointer"
              alt=""
            />
          </div>
        </div>
      </div>

      <div
        class="md:hidden flex items-center py-3 px-8 bg-surface-0 dark:bg-surface-900 border-b border-surface-200 dark:border-surface-700"
      >
        <div class="flex items-center gap-2">
          <a
            class="text-surface-600 dark:text-surface-400 text-base font-normal cursor-pointer"
            >Bookmarks</a
          >
          <i
            class="pi pi-angle-right text-base! leading-none! text-surface-600 dark:text-surface-400"
          ></i>
          <a
            class="text-surface-600 dark:text-surface-400 text-base font-normal cursor-pointer"
            >Favorites</a
          >
        </div>
      </div>

      <div class="flex relative flex-1">
        <div
          id="app-sidebar-floating"
          class="hidden lg:block shrink-0 absolute lg:static left-0 top-0 z-10 select-none h-full lg:h-auto"
        >
          <div class="h-full flex p-8 pr-0">
            <div>
              <div
                class="bg-surface-0 dark:bg-surface-900 rounded-xl shadow-md lg:border-0 border border-transparent dark:border-surface-700 w-[280px] flex flex-col h-full overflow-hidden"
              >
                <div class="overflow-y-auto flex-1">
                  <div class="p-4 flex flex-col gap-4">
                    <div class="flex flex-col">
                      <div
                        pStyleClass="@next"
                        enterFromClass="hidden"
                        enterActiveClass="animate-slidedown"
                        leaveToClass="hidden"
                        leaveActiveClass="animate-slideup"
                        class="flex items-center cursor-pointer p-3 gap-4 rounded-md text-surface-900 dark:text-surface-0 hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors duration-150 border border-transparent hover:border hover:border-surface-200 dark:hover:border-surface-700"
                      >
                        <span class="font-semibold text-base leading-tight"
                          >Home</span
                        >
                        <i
                          class="pi pi-angle-down text-base! leading-none! text-surface-500 dark:text-surface-400 ml-auto"
                        ></i>
                      </div>
                      <ul
                        class="list-none m-0 overflow-hidden flex flex-col gap-1"
                      >
                        <li>
                          <a
                            routerLink="/users"
                            class="flex items-center cursor-pointer p-3 gap-2 rounded-lg text-surface-700 dark:text-surface-200 hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors duration-150 hover:text-surface-900 dark:hover:text-surface-50 group border border-transparent hover:border hover:border-surface-200 dark:hover:border-surface-700"
                          >
                            <i
                              class="pi pi-home text-base! leading-none! text-surface-500 dark:text-surface-400 group-hover:text-surface-900 dark:group-hover:text-surface-50"
                            ></i>
                            <span class="font-medium text-base leading-tight"
                              >Dashboard</span
                            >
                          </a>
                        </li>
                        <li>
                          <a
                            class="flex items-center cursor-pointer p-3 gap-2 rounded-lg text-surface-700 dark:text-surface-200 hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors duration-150 hover:text-surface-900 dark:hover:text-surface-50 group border border-transparent hover:border hover:border-surface-200 dark:hover:border-surface-700"
                          >
                            <i
                              class="pi pi-bookmark text-base! leading-none! text-surface-500 dark:text-surface-400 group-hover:text-surface-900 dark:group-hover:text-surface-50"
                            ></i>
                            <span class="font-medium text-base leading-tight"
                              >Bookmarks</span
                            >
                            <p-badge
                              value="8"
                              severity="contrast"
                              class="ml-auto h-5! min-w-5! text-xs! font-bold! leading-tight! rounded-xl!"
                            ></p-badge>
                          </a>
                        </li>
                        <li>
                          <a
                            class="flex items-center cursor-pointer p-3 gap-2 rounded-lg text-surface-700 dark:text-surface-200 hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors duration-150 hover:text-surface-900 dark:hover:text-surface-50 group border border-transparent hover:border hover:border-surface-200 dark:hover:border-surface-700"
                          >
                            <i
                              class="pi pi-users text-base! leading-none! text-surface-500 dark:text-surface-400 group-hover:text-surface-900 dark:group-hover:text-surface-50"
                            ></i>
                            <span class="font-medium text-base leading-tight"
                              >Team</span
                            >
                          </a>
                        </li>
                        <li>
                          <a
                            class="flex items-center cursor-pointer p-3 gap-2 rounded-lg text-surface-700 dark:text-surface-200 hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors duration-150 hover:text-surface-900 dark:hover:text-surface-50 group border border-transparent hover:border hover:border-surface-200 dark:hover:border-surface-700"
                          >
                            <i
                              class="pi pi-inbox text-base! leading-none! text-surface-500 dark:text-surface-400 group-hover:text-surface-900 dark:group-hover:text-surface-50"
                            ></i>
                            <span class="font-medium text-base leading-tight"
                              >Messages</span
                            >
                            <p-badge
                              value="2"
                              severity="secondary"
                              class="ml-auto h-5! min-w-5! text-xs! font-bold! leading-tight! rounded-xl!"
                            ></p-badge>
                          </a>
                        </li>
                        <li>
                          <a
                            class="flex items-center cursor-pointer p-3 gap-2 rounded-lg text-surface-700 dark:text-surface-200 hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors duration-150 hover:text-surface-900 dark:hover:text-surface-50 group border border-transparent hover:border hover:border-surface-200 dark:hover:border-surface-700"
                          >
                            <i
                              class="pi pi-calendar text-base! leading-none! text-surface-500 dark:text-surface-400 group-hover:text-surface-900 dark:group-hover:text-surface-50"
                            ></i>
                            <span class="font-medium text-base leading-tight"
                              >Calendar</span
                            >
                          </a>
                        </li>
                      </ul>
                    </div>

                    <hr
                      class="border-t border-surface-200 dark:border-surface-800 my-0"
                    />

                    <div class="flex flex-col gap-1">
                      <div
                        pStyleClass="@next"
                        enterFromClass="hidden"
                        enterActiveClass="animate-slidedown"
                        leaveToClass="hidden"
                        leaveActiveClass="animate-slideup"
                        class="flex items-center cursor-pointer p-3 gap-4 rounded-md text-surface-900 dark:text-surface-0 hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors duration-150 border border-transparent hover:border hover:border-surface-200 dark:hover:border-surface-700"
                      >
                        <span class="font-semibold text-base leading-tight"
                          >Your Networks</span
                        >
                        <i
                          class="pi pi-angle-down text-base! leading-none! text-surface-500 dark:text-surface-400 ml-auto"
                        ></i>
                      </div>
                      <ul
                        class="list-none m-0 overflow-hidden flex flex-col gap-1 mt-1"
                      >
                        <li>
                          <a
                            class="flex items-center cursor-pointer p-3 gap-2 rounded-lg text-surface-700 dark:text-surface-200 hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors duration-150 hover:text-surface-900 dark:hover:text-surface-50 group border border-transparent hover:border hover:border-surface-200 dark:hover:border-surface-700"
                          >
                            <span
                              class="inline-flex items-center justify-center p-1 bg-violet-100 dark:bg-violet-500/20 rounded-md border border-violet-200 dark:border-violet-500/30"
                            >
                              <i
                                class="pi pi-sparkles text-xs! leading-none! text-violet-600 dark:text-violet-300"
                              ></i>
                            </span>
                            <span class="font-medium text-base leading-tight"
                              >Front-End Developers</span
                            >
                          </a>
                        </li>
                        <li>
                          <a
                            class="flex items-center cursor-pointer p-3 gap-2 rounded-lg text-surface-700 dark:text-surface-200 hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors duration-150 hover:text-surface-900 dark:hover:text-surface-50 group border border-transparent hover:border hover:border-surface-200 dark:hover:border-surface-700"
                          >
                            <span
                              class="inline-flex items-center justify-center p-1 bg-amber-100 dark:bg-amber-500/20 rounded-md border border-amber-200 dark:border-amber-500/30"
                            >
                              <i
                                class="pi pi-wrench text-xs! leading-none! text-amber-600 dark:text-amber-300"
                              ></i>
                            </span>
                            <span class="font-medium text-base leading-tight"
                              >Back-End Developers</span
                            >
                          </a>
                        </li>
                        <li>
                          <a
                            class="flex items-center cursor-pointer p-3 gap-2 rounded-lg text-surface-700 dark:text-surface-200 hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors duration-150 hover:text-surface-900 dark:hover:text-surface-50 group border border-transparent hover:border hover:border-surface-200 dark:hover:border-surface-700"
                          >
                            <span
                              class="inline-flex items-center justify-center p-1 bg-lime-100 dark:bg-lime-500/20 rounded-md border border-lime-200 dark:border-lime-500/30"
                            >
                              <i
                                class="pi pi-palette text-xs! leading-none! text-lime-600 dark:text-lime-300"
                              ></i>
                            </span>
                            <span class="font-medium text-base leading-tight"
                              >UI/UX Designers</span
                            >
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="p-4 mt-auto">
                  <a
                    class="flex items-center cursor-pointer gap-2 text-surface-900 dark:text-surface-0"
                  >
                    <img
                      src="https://fqjltiegiezfetthbags.supabase.co/storage/v1/render/image/public/block.images/blocks/avatars/avatar-amyels.png"
                      class="w-8 h-8 rounded-full"
                      alt=""
                    />
                    <span class="font-medium text-base leading-tight"
                      >Amy Elsner</span
                    >
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col flex-auto p-4 md:p-8">
          <div class="bg-surface-50 dark:bg-surface-950 h-full">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class FloatingMenuComponent {}
